import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "../../api";

// Polls unread counts and triggers browser notifications when they grow.
export default function NotificationsPoll({ onCounts }) {
  const lastRef = useRef(null);

  useEffect(() => {
    // request permission on mount if not decided
    if ("Notification" in window && Notification.permission === "default") {
      // don't force prompt; Settings has explicit CTA. Auto-ask once.
      Notification.requestPermission().catch(() => {});
    }

    let alive = true;
    const tick = async () => {
      try {
        const { data } = await api.get("/admin/notifications");
        if (!alive) return;
        onCounts?.(data);
        const prev = lastRef.current;
        if (prev) {
          const dq = data.quotes_new - prev.quotes_new;
          const da = data.appointments_new - prev.appointments_new;
          if (dq > 0 && data.latest_quote) {
            fire(`Nouvelle demande de devis`, `${data.latest_quote.name} — ${data.latest_quote.category}`);
            toast.message("Nouvelle demande de devis", { description: data.latest_quote.name });
          }
          if (da > 0 && data.latest_appointment) {
            fire(`Nouveau rendez-vous`, `${data.latest_appointment.name} — ${data.latest_appointment.date} ${data.latest_appointment.time}`);
            toast.message("Nouveau rendez-vous", { description: `${data.latest_appointment.date} ${data.latest_appointment.time}` });
          }
        }
        lastRef.current = data;
      } catch (_e) { /* ignore */ }
    };

    tick();
    const iv = setInterval(tick, 25000);
    return () => { alive = false; clearInterval(iv); };
  }, [onCounts]);

  return null;
}

function fire(title, body) {
  try {
    if (!("Notification" in window)) return;
    if (Notification.permission !== "granted") return;
    if (navigator.serviceWorker?.controller) {
      navigator.serviceWorker.ready.then((reg) => {
        reg.showNotification(title, {
          body,
          icon: "/icon-192.png",
          badge: "/icon-192.png",
          vibrate: [80, 40, 80],
          tag: title,
          renotify: true,
        });
      }).catch(() => {
        new Notification(title, { body, icon: "/icon-192.png" });
      });
    } else {
      new Notification(title, { body, icon: "/icon-192.png" });
    }
  } catch (_e) {}
}
